export const APP_SCREENS:Array<{name:string,getComponent:()=>any}>=[]